<template>
  <div>
    <h1 class="section-title" style="text-align: center; margin-top: 40px">
      {{ selectedVideo.name }}
    </h1>
    <ReturnBtn
      :path="
        this.path
          ? this.path
          : `${
              selectedVideo && selectedVideo.forBeginners
                ? 'subskrypcja-podstawy'
                : 'subskrypcja'
            }`
      "
      blackColor
    ></ReturnBtn>
    <div class="register-buttons">
      <a href="#" class="register"
        ><span class="logbtn" :class="{ active: selectedVersion === 'FULL' }"
          >Pełny dostęp</span
        ></a
      >
      <span class="or">/</span>

      <a href="#" class="login" @click="changeVersion()"
        ><span class="logbtn" :class="{ active: selectedVersion !== 'FULL' }"
          >Darmowa wersja</span
        >
      </a>
    </div>

    <div class="card">
      <div
        class="video-section"
        v-if="
          selectedVersion === 'FULL' &&
          (getCourseYoutubeId() !== '' || getDropboxLink !== '')
        "
      >
        <div v-if="hasActiveSubscription && !notAllowedToWatch">
          <video-player
            :videoId="getCourseYoutubeId()"
            :dropboxLink="getDropboxLink"
          />
        </div>
        <div class="text-center no-access" v-else>
          <h3 style="color: #8b857d; max-width: 400px">
            Aby uzyskać dostęp do kursów, musisz posiadać konto w serwisie oraz
            mieć aktywną subskrypcję.
          </h3>
          <button class="primary-button" @click="moveToAuth" v-if="!loggedIn">
            Zaloguj się
          </button>
          <button class="primary-button" @click="moveToSubscriptions">
            Wykup dostęp
          </button>
        </div>
      </div>

      <div class="video-section">
        <add-video-to-schedule
          v-if="selectedVideo"
          :selectedVideo="selectedVideo"
        />
      </div>

      <div class="video-section video-info-section">
        <div class="video-info-card">
          <svg
            width="54"
            height="40"
            viewBox="0 0 54 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M5.99524 19.4158C9.24459 10.9793 17.4271 5 27 5V0C15.291 0 5.29722 7.31668 1.32937 17.6185L5.99524 19.4158ZM27 5C36.5727 5 44.7552 10.9793 48.0045 19.4158L52.6705 17.6185C48.7025 7.3167 38.7087 0 27 0V5ZM48.0045 20.5842C44.7552 29.0208 36.5727 35 27 35V40C38.7087 40 48.7025 32.6833 52.6705 22.3815L48.0045 20.5842ZM27 35C17.4271 35 9.24459 29.0208 5.99524 20.5842L1.32937 22.3815C5.29722 32.6833 15.291 40 27 40V35ZM48.0045 19.4158C48.1492 19.7913 48.1492 20.2087 48.0045 20.5842L52.6705 22.3815C53.2607 20.849 53.2607 19.151 52.6705 17.6185L48.0045 19.4158ZM1.32937 17.6185C0.739169 19.151 0.739169 20.849 1.32937 22.3815L5.99524 20.5842C5.85054 20.2087 5.85054 19.7913 5.99524 19.4158L1.32937 17.6185Z"
              fill="#6D6963"
            />
            <path
              d="M27 27.5C31.1421 27.5 34.5 24.1421 34.5 20C34.5 15.8579 31.1421 12.5 27 12.5C22.8579 12.5 19.5 15.8579 19.5 20C19.5 24.1421 22.8579 27.5 27 27.5Z"
              stroke="#6D6963"
              stroke-width="5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>

          <div class="">{{ selectedVideo.viewsCounter }}</div>
        </div>
        <div
          class="video-info-card"
          @click="openNoteDialog"
          style="cursor: pointer"
        >
          <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M23.3333 3.33331H10C8.89493 3.33331 8 4.22824 8 5.33331V34.6666C8 35.7717 8.89493 36.6666 10 36.6666H30C31.1051 36.6666 32 35.7717 32 34.6666V12.3333L23.3333 3.33331Z"
              stroke="#6D6963"
              stroke-width="3"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M23.3333 3.33331V12.3333H32"
              stroke="#6D6963"
              stroke-width="3"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M25.3333 21.6666H14.6667"
              stroke="#6D6963"
              stroke-width="3"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M25.3333 28.3333H14.6667"
              stroke="#6D6963"
              stroke-width="3"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M17.3333 15H16H14.6667"
              stroke="#6D6963"
              stroke-width="3"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <div style="text-decoration: underline">{{ noteButtonText }}</div>
        </div>
        <!-- <div class="video-info-card">
          <svg
            width="47"
            height="47"
            viewBox="0 0 47 47"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M23.5 44C34.8218 44 44 34.8218 44 23.5C44 12.1782 34.8218 3 23.5 3C12.1782 3 3 12.1782 3 23.5C3 34.8218 12.1782 44 23.5 44Z"
              stroke="#6D6963"
              stroke-width="5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M23.5 11.1992V23.4992L31.7 27.5992"
              stroke="#6D6963"
              stroke-width="5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <div class="">{{ selectedVideo.viewsCounter }} min</div>
        </div> -->
        <div class="video-info-card">
          <svg
            width="53"
            height="47"
            viewBox="0 0 53 47"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M26.5 8.27703C15.9254 -2.8575 3 5.35603 3 16.9378C3 28.5194 12.4457 34.6912 19.3601 40.2153C21.8 42.1647 24.15 44 26.5 44"
              stroke="#6D6963"
              stroke-width="5"
              stroke-linecap="round"
            />
            <path
              d="M26.5 8.27703C37.0745 -2.8575 50 5.35603 50 16.9378C50 28.5194 40.5544 34.6912 33.64 40.2153C31.2 42.1647 28.85 44 26.5 44"
              stroke="#6D6963"
              stroke-width="5"
              stroke-linecap="round"
            />
          </svg>

          <div
            @click="handleFavourites"
            style="cursor: pointer; text-decoration: underline"
            class=""
          >
            {{
              selectedVideo.favorite
                ? "Usuń z ulubionych"
                : "Dodaj do ulubionych"
            }}
          </div>
        </div>
      </div>

      <div class="video-section description">
        <p
          v-html="
            selectedVideo
              ? htmlToFormattedText(selectedVideo.description)
              : course
              ? htmlToFormattedText(course.description)
              : ''
          "
        ></p>
      </div>
      <div class="video-section">
        <PracticeNote
          v-if="selectedVideo"
          ref="practiceNote"
          :timePackageItemId="selectedVideo.id"
          :allowDelete="true"
          :forBeginners="selectedVideo.forBeginners || false"
        />
      </div>
      <div class="video-section">
        <CommentSection
          v-if="selectedVideo"
          :id="selectedVideo ? selectedVideo.id : null"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ReturnBtn from "../components/ReturnBtn.vue";
import VideoPlayer from "../components/VideoPlayer.vue";
import CommentSection from "../components/CommentSection.vue";
import AddVideoToSchedule from "../components/AddVideoToSchedule.vue";
import PracticeNote from "../components/PracticeNote.vue";
import { getYoutubeIdFromUrl } from "../utils";

export default {
  name: "Videos",

  components: {
    ReturnBtn,
    VideoPlayer,
    CommentSection,
    AddVideoToSchedule,
    PracticeNote,
  },
  props: {
    course: Object,
  },

  data: () => ({
    playing: true,
    path: "",
    loggedIn: false,
    selectedVersion: "FULL",
    loading: false,
    notAllowedToWatch: false,
    courseFromUrl: null,
  }),

  async mounted() {
    if (this.$route.params.path) {
      this.path = this.$route.params.path;
    }

    const urlId = this.$router.currentRoute.query.id;
    if (urlId) {
      const id = String(urlId).split("_")[1];
      if (id) {
        const course = await this.$store.dispatch(
          "timePackages/getTimePackageItemById",
          id
        );
        if (course) {
          this.$store.dispatch("videos/setSelectedVideo", {
            video: course,
          });
          this.courseFromUrl = course;
        }
      }
    }

    await this.$store.dispatch(`auth/checkUserActiveSubscriptions`);
    await this.$store.dispatch(`auth/checkUserActiveSubscriptionsForBeginners`);

    if (this.hasActiveSubscription) {
      await this.$store.dispatch(`timePackages/fetchActiveSubscriptions`);
    } else {
      await this.$store.dispatch(`timePackages/setActiveSubscriptionsToNull`);
    }

    let includedInFreeSubscription = false;
    if (this.courseFromUrl) {
      if (this.course && this.course.includedInFreeSubscription) {
        includedInFreeSubscription = true;
      }
      if (this.selectedVideo && this.selectedVideo.includedInFreeSubscription) {
        includedInFreeSubscription = true;
      }
    } else if (this.course) {
      if (this.course.includedInFreeSubscription) {
        includedInFreeSubscription = true;
      }
      if (this.selectedVideo && this.selectedVideo.includedInFreeSubscription) {
        includedInFreeSubscription = true;
      }
    } else if (this.selectedVideo) {
      if (this.selectedVideo.includedInFreeSubscription) {
        includedInFreeSubscription = true;
      }
    }

    if (
      (!this.activeSubscriptions ||
        this.activeSubscriptions.length == 0 ||
        (this.activeSubscriptions.length < 2 &&
          this.activeSubscriptions[0].freeForRegistration)) &&
      !includedInFreeSubscription
    ) {
      //this.$router.push({ name: "VideosDemo" });
      this.notAllowedToWatch = true;
    }
    const token = window.localStorage.getItem("userToken");
    if (token) {
      this.loggedIn = true;
    }
  },

  methods: {
    openNoteDialog() {
      if (this.$refs.practiceNote) {
        this.$refs.practiceNote.openDialog();
      }
    },
    async handleFavourites() {
      if (!this.loading) {
        try {
          if (!this.selectedVideo.favorite) {
            this.loading = true;
            const response = await this.$store.dispatch(
              "timePackages/addToFavorite",
              {
                timePackageItemId: this.selectedVideo.id,
                withoutFetching: true,
              }
            );
            this.selectedVideo.favorite = true;
            this.selectedVideo.favoriteItemId = response.id;
          } else {
            this.loading = true;
            await this.$store.dispatch("timePackages/deleteFromFavourites", {
              favoriteItemId: this.selectedVideo.favoriteItemId,
              withoutFetching: true,
            });
            this.selectedVideo.favorite = false;
          }
        } catch (error) {
          console.log(error);
        } finally {
          this.loading = false;
        }
      }
    },
    htmlToFormattedText(text) {
      const regex =
        /((http|https|ftp|ftps):\/\/[a-zA-Z0-9\-.]+\.[a-zA-Z]{2,3}(\/\S*)?)/g;
      text = text.replace(regex, '<a href="$1">$1</a>');
      return text;
    },
    changeVersion() {
      this.$router.push({
        name: "VideosDemo",
        query: {
          id: `${this.selectedVideo.name.replaceAll(" ", "-")}_${
            this.selectedVideo.id
          }`,
        },
        params: { path: this.path },
      });
    },
    getDemoCourseYoutubeId() {
      let courseLink;
      if (this.courseFromUrl) {
        courseLink = this.courseFromUrl.demoLink;
      } else if (this.selectedVideo) {
        courseLink = this.selectedVideo.demoLink;
      } else if (this.course) {
        courseLink = this.course.demoLink;
      } else {
        return "";
      }
      return getYoutubeIdFromUrl(courseLink);
    },

    getCourseYoutubeId() {
      let courseLink;
      if (this.courseFromUrl) {
        courseLink = this.courseFromUrl.link;
      } else if (this.selectedVideo) {
        courseLink = this.selectedVideo.link;
      } else if (this.course) {
        courseLink = this.course.link;
      } else {
        courseLink = "";
      }

      return getYoutubeIdFromUrl(courseLink);
    },

    moveToAuth() {
      this.$router.push({ name: "Auth", params: { previousPage: "Videos" } });
    },
    moveToSubscriptions() {
      if (this.selectedVideo && this.selectedVideo.forBeginners) {
        this.$router.push({ name: "TimeSubscriptionsForBeginners" });
      } else {
        this.$router.push({ name: "TimeSubscriptions" });
      }
    },
  },

  computed: {
    noteButtonText() {
      if (!this.selectedVideo) return "Dodaj notatkę";
      const note = this.$store.getters["notes/getNoteByVideoId"](
        this.selectedVideo.id
      );
      return note ? "Edytuj notatkę" : "Dodaj notatkę";
    },
    getDropboxLink() {
      let courseLink;
      if (this.courseFromUrl) {
        courseLink = this.courseFromUrl.linkDropbox;
      } else if (this.selectedVideo) {
        courseLink = this.selectedVideo.linkDropbox;
      } else if (this.course) {
        courseLink = this.course.linkDropbox;
      } else {
        courseLink = "";
      }

      const videoLink = courseLink ? courseLink.replace("dl=0", "raw=1") : "";
      return videoLink;
    },

    getDemoCourseDropboxLink() {
      let courseLink;
      if (this.courseFromUrl) {
        courseLink = this.courseFromUrl.demoLinkDropbox;
      } else if (this.selectedVideo) {
        courseLink = this.selectedVideo.demoLinkDropbox;
      } else if (this.course) {
        courseLink = this.course.demoLinkDropbox;
      } else {
        courseLink = "";
      }

      const videoLink = courseLink ? courseLink.replace("dl=0", "raw=1") : "";
      return videoLink;
    },
    selectedVideo() {
      return this.$store.getters["videos/getSelectedVideo"];
    },
    timePackageItems() {
      let courses = this.$store.getters["timePackages/getTimePackageItems"];
      return courses;
    },
    hasActiveSubscription() {
      if (this.selectedVideo && this.selectedVideo.forBeginners) {
        return this.$store.getters["auth/getHasActiveSubscriptionForBeginners"];
      } else {
        return this.$store.getters["auth/getHasActiveSubscription"];
      }
    },
    activeSubscriptions() {
      if (this.selectedVideo && this.selectedVideo.forBeginners) {
        return this.$store.getters[
          "timePackages/getActiveSubscriptionsForBeginners"
        ];
      } else {
        return this.$store.getters["timePackages/getActiveSubscriptions"];
      }
    },
  },
};
</script>

<style scoped>
.card {
  width: 70vw;
  max-width: 1300px !important;
  margin: 0 auto;
  margin-bottom: 40px;
  padding: 20px;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  border-radius: 10px;
  display: block;
  position: relative;
  margin-top: 20px;
}
.text-under {
  padding: 20px 30px;
  border-top: 1px solid lightgray;
}

.text-under .background {
  padding: 5px 40px;
  font-size: 1.25rem;
  background: linear-gradient(270deg, #c4a2a2 0%, #b28a8a 90.06%);
  color: #fff;
  text-align: center;
  border-radius: 5px;
  transition: all 0.3s ease;
}

h3 {
  margin-bottom: 20px;
  font-size: 1.3rem;
  font-weight: 400;
}

.no-access .background {
  padding: 8px 22px;
  width: 150px;
  border-radius: 30px;
  font-size: 1rem;
  margin: 15px;
  color: #fff;
  background: linear-gradient(270deg, #c4a2a2 0%, #b28a8a 90.06%);
  border-radius: 5px;
  text-align: center;
  transition: all 0.3s ease;
  font-weight: 500;
}
.no-access {
  display: flex;
  flex-direction: column;
  justify-items: center;
  align-items: center;
  padding-top: 3rem;
  height: 100%;
  min-height: 300px;
  max-height: 600px;
  /* width: 80%; */
  margin: 0 auto;
  background: #fff;
  border-radius: 30px;
  /* background-image: url("../assets/background-video.png"); */
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
}
.switch {
  position: absolute;
  display: flex;
  top: 0;
  left: 0;
}
.switch div {
  padding: 1rem;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;

  font-size: 15px;
  cursor: pointer;
}
.switch .btn-gradient {
  height: 40px;
  display: flex;
  align-items: center;
  background: rgb(233, 230, 230);
  color: black;
}
.switch .btn-gradient:hover {
  transform: none;
}
.selectedSwitch {
  background: rgb(179, 106, 103) !important;
  background: linear-gradient(270deg, #c4a2a2 0%, #b28a8a 90.06%) !important;
  color: #fff !important;
}
.viewsCounter {
  color: grey;
  font-size: 0.8rem;
  margin-right: 0.8rem;
}
.favorite-button {
  color: rgb(78, 74, 74);
  font-size: 0.9rem;
  margin-right: 0.8rem;
  display: flex;
  align-items: center;
  justify-content: right;
  text-decoration: underline;
  cursor: pointer;
}
.favorite-icon {
  margin-right: 8px;
  font-size: 0.9rem;
  cursor: pointer;
}

/* @media (max-width: 1024px) {

} */

@media screen and (max-width: 700px) {
  .card {
    width: 90vw;
  }
}
@media screen and (max-width: 550px) {
  .no-access h3 {
    font-size: 1.1rem;
  }
}
@media screen and (max-width: 450px) {
  .no-access .btn-gradient {
    font-size: 0.8;
    width: 160px;
  }
  .no-access h3 {
    font-size: 1rem;
  }
  .card {
    width: 100vw;
  }
  .text-under {
    font-size: 0.8rem;
    padding: 20px 5px;
  }
}
@media screen and (max-width: 375px) {
  .no-access h3 {
    font-size: 0.8rem;
  }
}

.register-buttons {
  display: flex;
  margin: 10px auto;
  width: fit-content;
  background: #d9d9d9;
  padding: 10px 15px;
  border-radius: 30px;
  align-items: center;
}

.active {
  padding: 10px 0;
  font-weight: 800;
  opacity: 1;
  position: relative;
}

a {
  text-decoration: none;
}
.logbtn {
  color: #6d6963;
  font-size: 24px;
  opacity: 0.7;
  transition: 0.5s all ease;
  font-size: 16px;
}
.logbtn:hover {
  opacity: 1;
}

.or {
  color: #6d6963;
  padding: 0 10px;
  font-size: 16px;
}
@media screen and (max-width: 500px) {
  .logbtn {
    font-size: 18px;
  }
  .or {
    font-size: 18px;
  }
}
.video-info-section {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 50px;
  margin-top: 30px;
}
.video-info-card {
  background: #d9d9d9;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 250px;
  height: 100px;
  color: #6d6963;
  border-radius: 20px;
}
.video-info-card svg {
  max-width: 30px;
}
.video-section {
  width: 100%;
  max-width: 100%;
}
.description {
  color: #54514c;
  margin-top: 50px;
}
.section-title {
  font-size: 36px;
}
</style>
